import * as React from "react";

const SvgPersonRounded = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "#666666"}
      d="M12 12c-1.1 0-2.041-.392-2.825-1.175C8.392 10.042 8 9.1 8 8s.392-2.042 1.175-2.825C9.958 4.392 10.9 4 12 4s2.042.392 2.825 1.175C15.608 5.958 16 6.9 16 8s-.392 2.042-1.175 2.825C14.042 11.608 13.1 12 12 12M4 18v-.8c0-.567.146-1.087.438-1.562A3.17 3.17 0 0 1 5.6 14.55c1.033-.517 2.083-.904 3.15-1.162A14 14 0 0 1 12 13a14 14 0 0 1 3.25.388c1.067.26 2.117.647 3.15 1.162.483.25.871.613 1.163 1.088.292.475.437.996.437 1.562V18c0 .55-.196 1.021-.587 1.413A1.93 1.93 0 0 1 18 20H6c-.55 0-1.02-.196-1.412-.587A1.93 1.93 0 0 1 4 18"
    />
  </svg>
);

export default SvgPersonRounded;